<template>
  <div class="fillcontain">
    <div class="table_container">
      <el-row>
        <el-col :span="4">
          <el-input placeholder="请输入菜品名字或编号查询" v-model="pages.keyword" class="input-with-select">
          </el-input>
        </el-col>
        <el-col :span="6" style="margin-left: 10px">
          <el-button @click="initData">搜索</el-button>
          <el-button type="primary" @click="handleEdit(0, null,'add')">新增菜品</el-button>
        </el-col>
      </el-row>
      <br/>
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading">
        <el-table-column label="主图">
          <template slot-scope="scope">
            <img :src="scope.row.pics[0].showThumbnail" v-if="scope.row.pics.length > 0" width="50" height="50"/>
          </template>
        </el-table-column>
        <el-table-column
          label="菜名"
          prop="name">
        </el-table-column>

        <el-table-column
          label="编号"
          prop="number">
        </el-table-column>

        <el-table-column
          label="划线价"
          :formatter="markerPriceFormat">
        </el-table-column>

        <el-table-column
          label="销售价"
          :formatter="sellPriceFormat">
        </el-table-column>
        <el-table-column
          label="成本价"
          :formatter="costPriceFormat">
        </el-table-column>


        <el-table-column
          label="备注"
          prop="note"
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
          label="状态"
          :formatter="statusFormat">
        </el-table-column>

        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row,'edit')">
              编辑
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDeleteAlert( scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pages.page"
          :page-size="pages.pageSize"
          layout="total, prev, pager, next"
          :total="pages.total">
        </el-pagination>
      </div>

      <el-dialog :title="dialog.title" :visible.sync="dialog.dialogFormVisible" :close-on-click-modal="dialog.close">
        <el-form :model="goods">

          <el-form-item label="名称" label-width="80px">
            <el-input v-model="goods.name" auto-complete="off" maxlength="100" show-word-limit></el-input>
          </el-form-item>

          <el-form-item label="首字母" label-width="80px">
            <el-input v-model="goods.allFirstPingYin" auto-complete="off" maxlength="100" show-word-limit></el-input>
            <el-alert
              v-if="goods.kitchenPrinter == 0"
              title="汉字名称的所有拼音的首字母,用于快捷搜索，如'宫爆鸡丁'的输入'GBJD'"
              type="warning">
            </el-alert>
          </el-form-item>
          <el-form-item label="编号" label-width="80px">
            <el-input v-model="goods.number" auto-complete="off" maxlength="100" show-word-limit></el-input>
          </el-form-item>

          <el-form-item label="市场价" label-width="80px">
            <el-input-number :min=0 :max=1000000 v-model="goods.marker_price" auto-complete="off"></el-input-number>
          </el-form-item>

          <el-form-item label="销售价" label-width="80px">
            <el-input-number :min=0 :max=1000000 v-model="goods.sell_price" auto-complete="off"></el-input-number>
          </el-form-item>

          <el-form-item label="成本价" label-width="80px">
            <el-input-number :min=0 :max=1000000 v-model="goods.cost_price" auto-complete="off"></el-input-number>
          </el-form-item>

          <el-form-item label="积分" label-width="80px">
            <el-input-number :min=0 :max=1000000 v-model="goods.points" auto-complete="off"></el-input-number>
            <el-alert
              title="开通会员卡时会统计积分到客户的会员卡中，每天晚上统计前一天的消费数据并生成积分"
              type="warning">
            </el-alert>
          </el-form-item>

          <el-form-item label="备注" label-width="80px">
            <el-input v-model="goods.note" type="textarea" rows="4" maxlength="120" show-word-limit></el-input>
          </el-form-item>

          <el-form-item label="状态" label-width="80px">

            <el-switch
              v-model="goods.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="上架"
              inactive-text="下架"
              active-value="2"
              inactive-value="1">
            </el-switch>
          </el-form-item>
          <el-form-item label="只限内部员工查看" label-width="150px">
            <el-switch
              v-model="goods.outsideStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="不限制"
              inactive-text="限制"
              active-value="1"
              inactive-value="2">
            </el-switch>
            <el-alert
              v-if="goods.outsideStatus == 2"
              title="开启只限内部员工查看时,本菜品将不在客人的电子菜单上显示，但不影响店内员工的点餐端显示，适合碗筷等产品录入"
              type="warning">
            </el-alert>
          </el-form-item>
          <el-form-item label="分组" label-width="120px" v-loading="groups_loading">
            <span v-if="groupsChecks == null || groupsChecks.length == 0"
                  style="color: red">暂无菜品分组,您可以到菜品分组页面进行创建分组</span>
            <el-radio style="padding-bottom: 35px" border v-else v-model="goods.goods_group_id" :label="item.id"
                      v-for="(item,index) in groupsChecks" :key="index"><img :src="item.pic.showThumbnail"
                                                                             v-if="item.pic != null" width="25"
                                                                             height="25"/> {{ item.name }}
            </el-radio>
          </el-form-item>
          <el-form-item label="菜品标签" label-width="120px" v-loading="tag_item_loading">
            <el-collapse>
              <el-collapse-item :name="index" v-for="(tag,index) in goodsTags" :key="index">
                <template slot="title">
                  {{ tag.name }}<span v-if="tag.type == 1">(属性)</span><span v-else-if="tag.type == 2">(规格)</span><span
                  v-else-if="tag.type == 3">(配菜)</span>
                </template>
                <div>
                  <el-button @click="handleAddTagItemAlert( tag)">新增</el-button>
                </div>
                <div>
                  <el-table
                    :data="tag.items"
                    style="width: 100%">
                    <el-table-column label="名称">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.name" maxlength="100" show-word-limit></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="金额" v-if="tag.type == 2 || tag.type == 3">
                      <template slot-scope="scope">
                        <el-input-number v-model="scope.row.price"></el-input-number>
                      </template>
                    </el-table-column>
                    <el-table-column label="排序">
                      <template slot-scope="scope">
                        <el-input-number v-model="scope.row.showSort"></el-input-number>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200">
                      <template slot-scope="scope">
                        <el-button
                          size="mini"
                          type="danger"
                          @click="handleDeleteTagItemAlert(tag.items,scope.row)">
                          删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-collapse-item>

            </el-collapse>

          </el-form-item>
          <el-form-item label="制作队列" label-width="120px">
            <el-switch
              v-model="goods.kitchenPrinter"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="进入"
              inactive-text="不进入"
              active-value="1"
              inactive-value="0">
            </el-switch>
            <el-alert
              v-if="goods.kitchenPrinter == 0"
              title="【不进入】是指本产品将不进入厨房的制作队列,适合如碗筷等不需要在后厨制作出来的产品"
              type="warning">
            </el-alert>
            <el-alert
              v-if="goods.kitchenPrinter == 1"
              title="【进入】是指本产品将进入厨房的制作队列,后厨设备将显示或打印相应需要制作的菜品"
              type="warning">
            </el-alert>
          </el-form-item>
          <el-form-item label="指定后厨打印机" label-width="120px" v-loading="printer_loading"
                        v-if="goods.kitchenPrinter == 1">
            <div v-if="printerChecks.length == 0">
              <span style="color: red">暂无后厨相关打印机,您可以到打印机配置页面进行配置打印机（此处如不配置对应打印机，则默认所有的后厨打印机都会进行打印）</span>
            </div>
            <div v-else>
              <el-checkbox border v-for="(item,index) in printerChecks" :key="index" :label="item.name"
                           v-model="item.check" border></el-checkbox>
            </div>
          </el-form-item>

          <el-form-item label="图片" label-width="80px">
            <div style="text-align: left;margin: 5px">
              <el-upload
                :action="uploadUrl"
                list-type="picture-card"
                :on-preview="handlPicPreview"
                :before-remove="handleBeforeRemove"
                :on-success="handleSuccess"
                :file-list="picFiles"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div v-show="picVisible" size="tiny">
                <img width="100%" :src="picUrl" alt="">
              </div>
            </div>
          </el-form-item>


        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
      </el-dialog>


    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uploadUrl: window.server.baseUrl + '/common/imageUpload',
      loading: false,
      printer_loading: false,
      tag_item_loading: false,
      groups_loading: false,
      goods: {
        id: 0,
        name: "",
        allFirstPingYin: "",
        number: "",
        marker_price: "",
        sell_price: "",
        cost_price: "",
        note: "",
        status: "1",
        pic_ids: "",
        printer_ids: "",
        kitchenPrinter: "1",
        outsideStatus: "",
        goods_group_id: 0,
        points: 0,
        tag_items: [],

      },
      dialog: {
        dialogFormVisible: false,
        title: "新增分店",
        close: false,
      },
      pages: {
        offset: 0,
        pageSize: 30,
        page: 1,
        total: 0,
        keyword: "",
      },
      tableData: [],
      picFiles: [],
      picVisible: false,
      picUrl: "",
      goodsTags: [],
      tagItemsMap: [],
      groupsChecks: [],
      printerChecks: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.loading = true;
      var that = this;
      that.$api.get('/store/goods', that.pages, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            that.tableData = res.data.goods.content;
            that.pages.total = res.data.goods.totalElements;

          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
        this.loading = false;
      });
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pages.page = val;
      this.pages.offset = (val - 1) * this.pages.pageSize;
      this.initData()
    },
    statusFormat(row, column) {
      return row.status == 2 ? "上架" : "下架";
    },
    markerPriceFormat(row, column) {
      return row.marker_price / 100;
    },
    sellPriceFormat(row, column) {
      return row.sell_price / 100;
    },
    costPriceFormat(row, column) {
      return row.cost_price / 100;
    },
    handleBeforeRemove(file, fileList) {
      var that = this;
      this.$confirm('此操作将删除该图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.handleRemove(file, fileList);
      }).catch(() => {

      });
      return false;
    },
    handleRemove(file, fileList) {
      console.log(file);
      var index = this.picFiles.indexOf(file);
      console.log(index);
      if (index > -1) {
        this.picFiles.splice(index, 1);
      }
      console.log(this.picFiles)
    },
    handleSuccess(response, file, fileList) {
      file.id = response.ids[0];
      console.log(response);
      file.url = response.thumbnails[0];
      file.downloadUrl = response.data[0];

      file.ext = response.exts[0];
      this.picFiles.push(file);
    },
    handlPicPreview(file) {
      console.log(file);
      //BMP,JPG、JPEG、PNG
      if (file.ext.toLowerCase() == ".jpg" || file.ext.toLowerCase() == ".bmp" || file.ext.toLowerCase() == ".jpeg" || file.ext.toLowerCase() == ".png") {
        if (this.picUrl == file.downloadUrl) {
          this.picVisible = !this.picVisible;
        } else {
          this.picVisible = true;
        }
        this.picUrl = file.downloadUrl;

      } else {
        this.picVisible = false;
        location.href = file.downloadUrl;
      }

    },
    in_array(search, array) {
      for (var i in array) {
        if (array[i] == search) {
          return true;
        }
      }
      return false;
    },
    handleEdit(index, row, action) {
      //获取标签
      this.getPrinters(action, row);
      this.getGoodGroups(action, row);
      this.getGoodTagsItems(action, row);

      this.picFiles = new Array();
      if (action == "edit") {
        this.dialog.title = "修改菜品";
        this.goods.id = row.id;
        this.goods.number = row.number;
        this.goods.name = row.name;
        this.goods.allFirstPingYin = row.allFirstPingYin;
        this.goods.marker_price = row.marker_price / 100;
        this.goods.sell_price = row.sell_price / 100;
        this.goods.cost_price = row.cost_price / 100;
        this.goods.note = row.note;
        this.goods.points = row.points;
        this.goods.status = "" + row.status;
        this.goods.outsideStatus = "" + row.outsideStatus;
        this.goods.kitchenPrinter = "" + row.kitchenPrinter;
        this.goods.goods_group_id = row.goodsGroup != null ? row.goodsGroup.id : 0;
        console.log(row);
        console.log(this.goods);
        if (row.pics != null && row.pics.length > 0) {//图片处理
          var len = row.pics.length;
          if (len > 0) {
            for (var i = 0; i < len; i++) {
              var imgObj = row.pics[i];
              var img = {
                name: imgObj.name,
                url: imgObj.showThumbnail,
                id: imgObj.id,
                downloadUrl: imgObj.showUrl,
                ext: imgObj.ext
              }
              this.picFiles.push(img);
            }
          }
        }
        this.dialog.dialogFormVisible = true;
      } else if (action == "add") {
        this.dialog.title = "新增菜品";
        this.goods.id = 0;
        this.goods.number = "";
        this.goods.name = "";
        this.goods.allFirstPingYin = "";
        this.goods.marker_price = "";
        this.goods.sell_price = "";
        this.goods.cost_price = "";
        this.goods.note = "";
        this.goods.status = "";
        this.goods.outsideStatus = "";
        this.goods.kitchenPrinter = "0";
        this.goods.goods_group_id = 0;
        this.goods.points = 0;
        this.dialog.dialogFormVisible = true;
      }
    },

    getPrinters(action, row) {
      this.printer_loading = true;
      var that = this;
      this.printerChecks = [];
      that.$api.get('/store/printer/kitchenPrinters', {}, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            var printers = res.data.printers;
            var len = printers.length;
            if (len > 0) {
              for (var i = 0; i < len; i++) {
                var value = printers[i];
                this.printerChecks.push({check: false, name: value.name, id: value.id});
              }
              if (action == "edit") {
                if (row.printers.length > 0 && this.printerChecks.length > 0) {//标签选中处理
                  var cids = new Array();
                  for (var i = 0; i < row.printers.length; i++) {
                    var value = row.printers[i];
                    cids.push(value.id);
                  }
                  for (var i = 0; i < this.printerChecks.length; i++) {
                    var value = this.printerChecks[i];
                    if (this.in_array(value.id, cids)) {
                      this.printerChecks[i].check = true;
                    }
                  }
                }
              }
            }
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中1",
            type: 'error'
          });
        }
        this.printer_loading = false;
      });
    },

    getGoodTagsItems(action, row) {
      this.tag_item_loading = true;
      var that = this;
      var id = 0;
      if (row != null) {
        id = row.id;
      }
      this.$api.get('/store/goods/' + id + '/tag/items', {}, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            this.goods.tag_items = res.data.tagItems;
            this.goodsTags = res.data.goods_tags;
            this.tagItemsMap = res.data.tagItemsMap;
            this.goodsTags.forEach(function (tag, index) {
              let id = tag.id;
              if (that.tagItemsMap[id]) {
                tag.items = that.tagItemsMap[id];
                tag.items.forEach(function (item, index) {
                  item.price = item.price / 100;//转为元
                })
              } else {
                tag.items = [];
              }
            });
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
        this.tag_item_loading = false;
      });
    },
    getGoodGroups(action, row) {
      this.groups_loading = true;
      //获取标签
      this.groupsChecks = [];
      this.$api.get('/store/goods_groups', {page: 1, pageSize: 10000}, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            this.groupsChecks = res.data.goods_groups.content;
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
        this.groups_loading = false;
      });
    },
    handleAddTagItemAlert(tag) {
      var timestamp = Date.parse(new Date());
      tag.items.push({id: -timestamp, name: "", price: 0, showSort: 100, goodsTagId: tag.id})
    },
    handleDeleteTagItemAlert(items, row) {
      let index1 = items.findIndex(item => item.id == row.id);
      if (index1 > -1) {
        items.splice(index1, 1);
      }
    },
    handleSave() {
      var that = this;
      if (that.goods.name == '') {
        this.$message({
          message: "名字不能为空",
          type: 'warning'
        });
        return;
      }
      this.loading = true;
      that.goods.pic_ids = "";
      for (let i = 0, len = this.picFiles.length; i < len; i++) {
        that.goods.pic_ids += this.picFiles[i].id + "#";
      }
      that.goods.printer_ids = "";
      this.printerChecks.forEach(function (value, i) {
        if (value.check == true) {
          that.goods.printer_ids += value['id'] + "#";
        }
      });

      var tagItems = [];
      this.goodsTags.forEach(function (tag, i) {
        if (tag.items.length > 0) {
          tag.items.forEach(function (item, i) {
            item.goodsTagId = tag.id;
            item.price = item.price * 100;//转为分
            console.log(item);
            tagItems.push(item);
          });
        }
      });
      if (tagItems.length > 0) {
        that.goods.tag_items = JSON.stringify(tagItems);
      } else {
        that.goods.tag_items = "";
      }

      that.$api.post('/store/goods', that.goods, response => {
        if (response.status >= 200 && response.status < 300) {
          console.log(response.data);
          var res = response.data;
          if (res.code == 0) {
            this.$message({
              message: that.dialog.title + '成功',
              type: 'success'
            });
            this.dialog.dialogFormVisible = false;
            this.initData();
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }

      });

      this.loading = false;
    },
    handleDeleteAlert(row) {
      this.$confirm('此操作将删除该菜品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDelete(row);
      }).catch(() => {

      });
    },
    handleDelete(row) {
      this.loading = true;
      var that = this;
      that.$api.delete('/store/goods/' + row.id, null, response => {
        if (response.status >= 200 && response.status < 300) {
          console.log(response.data);
          var res = response.data;
          if (res.code == 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.loading = false;
            this.initData();
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }

      });
    },
  },
}
</script>

<style lang="less">
@import '../../style/mixin';

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.table_container {
  padding: 20px;
  text-align: left;
}

.Pagination {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/store/Goods.vue